<template>
  <div class="form-group">
    <label class="access-form__label">
      Code postal
      <abbr title="Ce champ est obligatoire">*</abbr>
    </label>
    <vv-provider tag="div" v-slot="{ errors, classes }" name="code postal">
      <div class="input-group has-icon-left">
        <i class="has-icon-left__icon fa fa-map-marker" aria-hidden="true"></i>
        <input
          class="form-control"
          type="text"
          :value="value"
          required
          v-mask="'99999'"
          :class="{ 'is-invalid': error || classes.invalid }"
          @input="$emit('input', $event.target.value)"
        />
      </div>
      <p class="mt-1 mb-0 text-danger smaller">
        {{ errors[0] }}
      </p>
    </vv-provider>
    <p class="mt-1 mb-0 text-danger smaller">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ZipCodeInput',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    error: {
      type: String,
      default: null
    }
  }
}
</script>
